module.exports = __webpack_public_path__ + "productivity3.png?6dc668b44d7ff6de2175488e3750221e";